import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_BASE_URL}/api`;
interface Credentials {
    token: string; 
  }

export const googleauthUser = async (credentials: Credentials) => {
  const API_URL = `${API_BASE_URL}/googleauth`;
  try {
    const response = await axios.post(API_URL, credentials, {
      withCredentials: true
    });

    return response;
  } catch (error) {
    throw error;
  }
};
